import { createSlice } from "@reduxjs/toolkit";

import {
  strategyListCases,
  removeStrategyCases,
  setErrorMessageReducer,
  setBacktestStatusLog,
  setStartedBacktestReducer,
  setIsBacktestCompleteReducer,
  setStrategyTypeReducer,
} from "./reducer";

const initialState = {
  strategies: [],
  backtestStatusLog: [],
  communityStrategies: [],
  strategyId: null,
  loading: false,
  isLoadingDelete: false,
  errorMessage: "",
  refetchStrategies: false,
  deletingStrategyId: null,
  startedBacktest: false,
  isBacktestComplete: false,
  strategyType: "",
};

export const strategySlice = createSlice({
  name: "strategy",
  initialState,
  reducers: {
    setErrorMessage: setErrorMessageReducer,
    setBacktestLog: setBacktestStatusLog,
    setStartedBacktest: setStartedBacktestReducer,
    setIsBacktestComplete: setIsBacktestCompleteReducer,
    setStrategyType: setStrategyTypeReducer,
    setRefetchStrategies: (state, action) => {
      state.refetchStrategies = action.payload;
    },
  },
  extraReducers: (builder) => {
    strategyListCases(builder);
    removeStrategyCases(builder);
  },
});

export const {
  setErrorMessage,
  setBacktestLog,
  setStartedBacktest,
  setIsBacktestComplete,
  setStrategyType,
  setRefetchStrategies,
} = strategySlice.actions;
export default strategySlice.reducer;
